import { createIcon } from './createIcon'

export const MilestoneCalendarIcon = createIcon({
  displayName: 'MilestoneCalendarIcon',
  viewBox: '0 0 12 12',
  path: [
    <path
      fill="none"
      id="Icon"
      d="M1.5 5.5H10.5M4 3.5V1.5M8 3.5V1.5M4.7 11.5H7.3C8.4201 11.5 8.98016 11.5 9.40798 11.282C9.78431 11.0903 10.0903 10.7843 10.282 10.408C10.5 9.98016 10.5 9.42011 10.5 8.3V5.7C10.5 4.5799 10.5 4.01984 10.282 3.59202C10.0903 3.21569 9.78431 2.90973 9.40798 2.71799C8.98016 2.5 8.42011 2.5 7.3 2.5H4.7C3.5799 2.5 3.01984 2.5 2.59202 2.71799C2.21569 2.90973 1.90973 3.21569 1.71799 3.59202C1.5 4.01984 1.5 4.57989 1.5 5.7V8.3C1.5 9.4201 1.5 9.98016 1.71799 10.408C1.90973 10.7843 2.21569 11.0903 2.59202 11.282C3.01984 11.5 3.57989 11.5 4.7 11.5Z"
      stroke="currentColor"
      strokeLinecap="round"
    />,
  ],
})
